import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PARAM_LABEL_INTERVENTION } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { User } from 'src/app/shared/models/security/user';
import { Specialite } from 'src/app/shared/models/specialite';
import { SortOrder } from '../../beneficiaires/list-beneficiaire/list-beneficiaire.component';
import { AddMissionTypeModalComponent } from '../modal/add-mission-type-modal/add-mission-type-modal.component';
import { EditMissionTypeModalComponent } from '../modal/edit-mission-type-modal/edit-mission-type-modal.component';
import { MissionTypeName } from 'src/app/shared/enums/mission-type-name.enum';

@Component({
	selector: 'app-list-mission-type',
	templateUrl: './list-mission-type.component.html',
	styleUrls: ['./list-mission-type.component.scss']
})
export class ListMissionTypeComponent implements OnInit {
	missionTypes: MissionType[];
	currentPage = 1;
	itemsPerPage = 10;

	sortType = 'type';
	sortOrder: SortOrder = 'asc';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	searchedText: string = '';

	editMissionTypeModalRef: BsModalRef;
	addMissionTypeModalRef: BsModalRef;

	labelIntervention: string;
	isMobile: boolean = false;
	screenWidth: number;

	isFunderActive: boolean;

	isListingLoading: boolean = true;

	isSAE: boolean = false;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.isSAE = this.facade.dataStorageService.isSAE();

		this.user = this.facade.dataStorageService.getUser();
		this.getMissionTypes();
		if (this.facade.dataStorageService.isPlanificatrice()) {
			this.isAddable = true;
		}

		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);

		this.isFunderActive = this.facade.dataStorageService.isFunderActive();
	}

	getMissionTypes(): void {
		this.isListingLoading = true;

		this.facade.missionTypeService.getAllMissionTypes().subscribe({
			next: (types: MissionType[]) => {
				this.missionTypes = types;
				this.itemsPerPage = this.missionTypes.length >= 10 ? 26 : 10;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.facade.toastService.createHttpErrorToast(
					err.error.response ? err.error.response : '',
					err.status
				);
				this.isListingLoading = false;
			}
		});
	}

	getMissionTypeLabel(code: string) {
		const label = this.capitalizeFirstLetter(MissionTypeName[code]);
		if (label) {
			return '(' + label + ')';
		} else {
			return '';
		}
	}

	capitalizeFirstLetter(input: string): string {
		if (!input) return input; // handle empty input
		return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
	}

	// selectSpecialite(specialite: Specialite): void {
	// 	const link = ['/specialites', specialite.id];
	// 	this.router.navigate(link);
	// }

	// onClosed(dismissedAlert: any): void {
	// 	this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	// }

	openModalAjout() {
		this.addMissionTypeModalRef = this.modalService.show(
			AddMissionTypeModalComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addMissionTypeModalRef.onHide.subscribe((reason: string | any) => {
			this.getMissionTypes();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	openModalEdit(missionType: MissionType) {
		const initialState = {
			missionType: missionType
		};
		this.editMissionTypeModalRef = this.modalService.show(
			EditMissionTypeModalComponent,
			{
				class: 'modal-lg',
				initialState
			}
		);

		this.editMissionTypeModalRef.onHide.subscribe((reason: string | any) => {
			this.getMissionTypes();
		});
	}
}
